app.service('activeElement', function (console) {
	var element = null;
	function set(el) {
		if (el) {
			element = el;
			
		} else if (document.activeElement !== null &&
			document.activeElement !== document.body &&
			document.activeElement !== document.documentElement) {
			element = document.activeElement;
		} else {
			element = null;
		}
		console.log('Zapisanie aktywnego elementu', element);
	}
	function get() {
		return element;
	}

	return {
		set,
		get
	};
});